import { useEffect, useState } from "react";
import { checkIfIsTouchDevice } from "../../utils/browser/check-if-is-touch-device";

export function useTouchDeviceSensor() {
  const [isTouchDevice, setIsTouchDevice] = useState(checkIfIsTouchDevice());
  useEffect(() => {
    setIsTouchDevice(checkIfIsTouchDevice());
  }, []);

  return isTouchDevice;
}
